import { encryptID } from '@myap/ui-library'
import {
  useUserDetailsQuery,
  useEducationPeriodsQuery,
  useStudentProfileAndRegistrationQuery,
} from '.'

const useStudentInfo = () => {
  const [appUser, setAppUser] = useState({})
  // User Details
  const {
    data: userDetails = {},
    isLoading: isLoadingUserDetails,
  } = useUserDetailsQuery()
  const { studentId } = userDetails
  // Education Periods
  const {
    data: educationPeriodsData = {},
  } = useEducationPeriodsQuery({ id: studentId, myDetailsComplete: !isLoadingUserDetails })
  const { currentEducationPeriod = {} } = educationPeriodsData
  const hasEnrollments = currentEducationPeriod?.hasEnrollments ?? false
  const isRegistered = currentEducationPeriod?.isRegistered ?? false
  // Profile and Registration
  const {
    data: studentProfileAndRegistrationData = {},
    isLoading: loadingStudentProfileAndRegistrationData,
  } = useStudentProfileAndRegistrationQuery({
    educationPeriodCd: currentEducationPeriod?.code,
    studentId,
    skip: !hasEnrollments || !isRegistered,
  })

  useEffect(() => {
    if (!loadingStudentProfileAndRegistrationData) {
      const orgData = hasEnrollments
        ? {
            org: {
              code: studentProfileAndRegistrationData?.attendingOrg?.orgId,
              name: studentProfileAndRegistrationData?.attendingOrg?.orgName,
            },
          }
        : undefined
      const grade = hasEnrollments
        ? { gradeLevel: studentProfileAndRegistrationData?.grade }
        : undefined

      setAppUser({ role: 'student', ...(orgData ?? {}), ...(grade ?? {}) })
    }
  }, [
    loadingStudentProfileAndRegistrationData,
    hasEnrollments,
    studentProfileAndRegistrationData,
  ])

  return {
    appUser,
    hasEnrollments,
    encryptedStudentId: encryptID(userDetails?.studentId),
    epc: currentEducationPeriod?.code,
  }
}

export default useStudentInfo
